import { Component, Input, OnInit } from '@angular/core';
import { DomainRepoService } from '@client/app/services/api/domain-repo/domain-repo.service';
import { DomainService } from '@client/app/services/entities/domain/domain.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';

interface IpAddress {
    text: string;
}

@Component({
    selector: 'form-domain-exclude-ip',
    template: `
        <div class="mon-dialog-header">
            <page-header [header]="'Excluded IP addresses from statistics' | translate">
            </page-header>
        </div>
        <div class="mon-dialog-body-with-footer bg-body pt-2 form-domain-exclude-ip">
            <div class="card panel-monsido-card mx-5">
                <div class="card-header d-flex">
                    <h2 class="font-weight-300">{{ 'IP address' | translate }}</h2>
                </div>
                <div class="card-body">
                    <span class="form-text text-muted">
                        {{ 'Use * as a wildcard (ex. 192.168.1.*). Excluded IP addresses will only affect new visitors' | translate }}
                    </span>
                    <div>
                        <form-field-dynamic
                            [model]="ipAddresses"
                            [label]="'IP address' | translate"
                            type="text"
                            [confirmMsg]="'Remove this IP address?' | translate"
                            attrName="text">
                        </form-field-dynamic>
                    </div>
                </div>
            </div>
        </div>
        <div class="mon-dialog-footer text-right">
            <button
                class="btn btn-border-radius btn-secondary"
                monEventTrigger="actionTrigger"
                [monEventParams]="{action: 'domain-exclude-ip-save'}"
                (click)="save()"
                [disabled]="onSave">
                {{ 'Save and close' | translate }}
            </button>
        </div>
    `,
    standalone: false,
})
export class FormDomainExcludeIpComponent implements OnInit {
    @Input() domainId: number = 0;
    @Input() monDialogId: string = '';


    ipAddresses: IpAddress[] = [];
    onSave = false;
    progress: Promise<any> | null = null;

    constructor (
        private domainRepoService: DomainRepoService,
        private domainService: DomainService,
        private monDialog: MonDialog,
    ) {}

    ngOnInit (): void {
        this.onSave = false;
        this.ipAddresses = [];
        this.progress = this.domainRepoService.getExcludedIps(this.domainId).then((data) => {
            if (data) {
                const excludedIps = (data as any).excluded_ips;
                this.ipAddresses = excludedIps.map((ip: string) => {
                    return { text: ip };
                });
            }
        }).catch(() => {
            // Error handling is typically done by the service or interceptor
        });
    }

    save (): void {
        this.onSave = true;
        const params = {
            excluded_ips: this.ipAddresses.map((ip) => ip.text),
        };

        this.domainService
            .update(this.domainId, params as any)
            .then((data) => {
                this.close(data);
            })
            .catch(() => {
                // Error handling is typically done by the service or interceptor
            })
            .finally(() => {
                this.onSave = false;
            });
    }

    private close (data?: any): void {
        this.monDialog.close(this.monDialogId, data);
    }
}
